<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Datos Generales de Alta
              |  
              router-link.a.button.is-default.is-rounded.is-medium(to="/Inventario/")
                i.fas.fa-times
            br
        .columns
          .column.is-one-third
            .field
              label.label Ubicación
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="ubicacion")
                    option(value="") Selecciona la Ubicación
                    option(v-for="u in ubicaciones" :value="u.id") {{ u.nombre }}
                .icon.is-small.is-left
                  i.fas.fa-map-pin
          .column.is-one-third
            .field
              label.label Solicita
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="solicita")
                    option(value="" checked) Seleccione un Usuario
                    option(v-for="data in usuarios_Solicita" :value="data.id" :key="data.id") {{ data.nombre }}
                .icon.is-small.is-left
                  i.fas.fa-user-tag
          .column.is-one-third
            .field
              label.label Autoriza
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="autoriza")
                    option(v-for="data in usuarios_Autoriza" :value="data.id" :key="data.id" checked) {{ data.nombre }}
                .icon.is-small.is-left
                  i.fas.fa-user-check
        .columns
          .column.is-one-quarter.is-offset.one-quarter
            a.button.is-primary.is-rounded.is-medium(@click="saveAlta") Guardar
</template>

<script>
import Loader from '../shared/Loader.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import InventarioServices from '../../services/inventario/inventario'
import usuariosServices from '../../services/usuarios/usuarios'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'Altas',
  components: { Loader, NavBarInventario },
  data () {
    return {
      isLoading: true,
      ubicacion: '',
      area: '',
      solicita: '',
      autoriza: '',
      usuarios_Solicita: [],
      usuarios_Autoriza: [],
      isEditing: false,
      ubicaciones: [
        { id: 'IRGE', nombre: 'IRGE'},
        { id: 'TPA', nombre: 'TPA'},
        { id: 'EB00', nombre: 'EB00'},
        { id: 'EB01', nombre: 'EB01'},
        { id: 'EB02', nombre: 'EB02'},
        { id: 'EB03', nombre: 'EB03'},
        { id: 'EB04', nombre: 'EB04'},
        { id: 'ERM', nombre: 'ERM'},
        { id: 'LPGD', nombre: 'Ducto'}
      ],
    }
  },
  methods: {
    iniciarComponente () {
      this.area = this.userLogin.departamento
    },
    obtenerUsuarios () {
      usuariosServices.getUsuarios()
        .then(res => {
          console.log(res)
          if (res.length > 0) {
              let usersBd = res.map(this.convetirDataUser)
              let uSolicita = usersBd.filter( r => r.categoria === 1 || r.categoria === 2 || r.categoria === 3)
              let uAutoriza = usersBd.filter(user => user.departamento === this.userLogin.departamento && user.jefeArea === 1)
              this.usuarios_Solicita = uSolicita
              this.usuarios_Autoriza = uAutoriza
              this.isLoading = false
            } else {
              this.isLoading = false
            }
        })
    },
    convetirDataUser(user) {
      return {
        ...user,
        categoria: parseInt(user.categoria),
        departamento: parseInt(user.departamento)
      }
    },
    saveAlta () {
      let ahora = moment()
      let fechaI = ahora.startOf('month').format('YYYY-MM-DD')
      let fechaF = ahora.endOf('month').format('YYYY-MM-DD')
      let month = ahora.format('MM')
      let year = ahora.format('YY')
      let idAlta = '';
      InventarioServices.countAltas(fechaI, fechaF)
        .then(res => {
          console.log(res)

          if ( res.length > 0 ) {
            let idAltaStr = (res[0].id).toString()
            console.log(idAltaStr)

            let countId = idAltaStr.substr(10, 3)
            let numAlta = parseInt(countId) + 1
            console.log(numAlta)
              switch (true) {
                case (numAlta >= 0) && (numAlta < 10):
                  console.log('Mayor o igual a 0 -  Menor a 10')
                  idAlta = `ALTA-${year}${month}_00${numAlta}`
                  break
                case (numAlta >= 10) && (numAlta < 100):
                  console.log('Mayor o igual a 10 -  Menor a 100')
                  idAlta = `ALTA-${year}${month}_0${numAlta}`
                  break
                case (numAlta >= 100):
                  console.log('Mayor o igual a 100')
                  idAlta = `ALTA-${year}${month}_${numAlta}`
                  break
                default:
                  console.log('Default')
                  break
              }
          } else {
            idAlta = `ALTA-${year}${month}_001`
          }
          let nombreSolicita = this.usuarios_Solicita.find( user => user.id === this.solicita );
          let nombreAutoriza = this.usuarios_Autoriza.find( user => user.id === this.autoriza );
          console.log(nombreSolicita.nombre)
          console.log(nombreAutoriza.nombre)
          console.log(idAlta)
          let hoy = moment().format('YY-MM-DD HH:mm:ss')
              
            InventarioServices.addAlta(idAlta, hoy, this.userLogin.id, this.userLogin.nombre, this.ubicacion, this.solicita, nombreSolicita.nombre, this.autoriza, nombreAutoriza.nombre, this.area)
              .then(res => {
                console.log(res)

                if (res.success) {
                  this.isLoading = true
                  setTimeout(() => {
                    this.$router.push({ path: `/Inventario/Alta/Detalle/${idAlta}` })
                  }, 250)
                } else {
                  console.log(res.respuesta)
                }
              })
        })

    }
  },
  created () {
    this.iniciarComponente()
    this.obtenerUsuarios()
  },
  computed: {
    ...mapState(['logueado', 'userLogin'])
  }
}
</script>

<style lang="css" scoped>

</style>





// WEBPACK FOOTER //
// src/components/inventario_Componentes/AltaNueva.vue